// extracted by mini-css-extract-plugin
export var aboveInput = "_mj-0";
export var actionButton = "_mj-5";
export var actionButtonContainer = "_mj-1";
export var actionIcon = "_mj-6";
export var aiInfoContainer = "_mj-2";
export var attachmentWrapper = "_mj-7";
export var bold = "_mj-3";
export var checkIcon = "_mj-8";
export var clickingRecipientBar = "_mj-11";
export var commentThreadSwitch = "_mj-a";
export var draftImage = "_mj-b";
export var draftImageContainer = "_mj-c";
export var draftImages = "_mj-e";
export var editButton = "_mj-g";
export var editor = "_mj-f";
export var editorContainer = "_mj-y";
export var editorErrorTooltipWrapper = "_mj-9";
export var headerDivider = "_mj-h";
export var icon = "_mj-i";
export var info = "_mj-j";
export var internal = "_mj-n";
export var internalDivider = "_mj-k";
export var internalMessage = "_mj-l";
export var messageInputCard = "_mj-m";
export var messageInputForm = "_mj-o";
export var messageInputFormInternal = "_mj-p";
export var options = "_mj-q";
export var publicMessageCustomer = "_mj-s";
export var publicMessageMerchant = "_mj-r";
export var removeImageButton = "_mj-d";
export var replyButtons = "_mj-t";
export var showSignatureButton = "_mj-u";
export var spinner = "_mj-v";
export var verticalButtonDivider = "_mj-4";
export var visibilitySelector = "_mj-w";
export var warning = "_mj-x";
export var wrappingText = "_mj-z";
export var writingInternalNoteTopBorder = "_mj-10";